import { Icon } from '@chakra-ui/react';

export const TreeView = (props) => (
  <Icon viewBox="0 0 24 24" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M12.672 10.2238L11.536 9.0878C12.088 8.5438 12.8 8.0158 13.888 7.6558L14.28 9.2078C13.568 9.4638 13.08 9.8238 12.672 10.2238ZM16.8 11.1998L20 7.9998L16.8 4.7998L16.8 7.2158C16.152 7.2318 15.568 7.2798 15.064 7.3678L15.456 8.9198C15.84 8.8638 16.296 8.8238 16.8 8.8158L16.8 11.1998ZM16.8 19.1998L20 15.9998L16.8 12.7998L16.8 15.1918C13.856 15.1118 13 14.1678 12.096 13.1598C11.744 12.7598 11.36 12.3518 10.856 11.9998C11.248 11.7278 11.56 11.4158 11.848 11.0958L10.72 9.9678C10.04 10.7118 9.488 11.1998 8 11.1998L4 11.1998L4 12.7998L8 12.7998C9.616 12.7998 10.128 13.3678 10.904 14.2318C11.896 15.3358 13.128 16.6958 16.8 16.7918L16.8 19.1998Z"
      fill="currentColor"
    />
  </Icon>
);
